import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "Contact",
  class: "flex w-full flex-col items-center justify-start"
}
const _hoisted_2 = { class: "mb-20 w-full max-w-screen-2xl text-slate-300 lg:mx-12" }
const _hoisted_3 = { class: "flex flex-wrap justify-evenly px-[2%]" }
const _hoisted_4 = { class: "my-12 min-w-[20rem] flex-[1_0_30%] px-[4%] sm:min-w-[30rem]" }
const _hoisted_5 = { class: "whitespace-pre-line" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "w-[60%] flex-[1_0_60%] px-[2%]" }
const _hoisted_8 = { class: "flex w-full flex-col content-center items-start justify-center space-y-2 rounded-md bg-slate-800 p-2 text-slate-300 ring-1 ring-slate-700 ring-offset-slate-800" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-md" }, "Contact Form", -1)
const _hoisted_10 = { class: "whitespace-pre text-sm text-rose-500" }
const _hoisted_11 = { class: "whitespace-pre text-sm text-lime-500" }
const _hoisted_12 = {
  key: 0,
  class: "flex w-full flex-col flex-wrap content-center space-y-2 text-sm md:flex-row md:content-start md:items-start md:justify-start md:space-x-2 md:space-y-0"
}
const _hoisted_13 = { class: "w-full md:flex-[1_0_40%]" }
const _hoisted_14 = { class: "w-full md:flex-[1_0_50%]" }
const _hoisted_15 = {
  key: 1,
  class: "w-full text-sm"
}
const _hoisted_16 = {
  key: 2,
  class: "w-full text-sm"
}
const _hoisted_17 = {
  key: 3,
  class: "flex w-full items-center justify-between space-x-4 pt-2"
}
const _hoisted_18 = { class: "flex items-center justify-center" }
const _hoisted_19 = { class: "mr-2 text-nowrap text-sm" }
const _hoisted_20 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sub_heading = _resolveComponent("sub-heading")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_sub_heading, {
        class: "px-[6%]",
        value: _ctx.title
      }, null, 8, ["value"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.block), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactTypes, (contact, key) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "mt-10 hidden space-x-1 xl:block",
              key: key
            }, [
              _createElementVNode("span", null, _toDisplayString(contact.beforeLink), 1),
              _createElementVNode("a", {
                class: "text-amber-500",
                href: contact.link,
                target: "_blank"
              }, _toDisplayString(contact.linkText), 9, _hoisted_6),
              _createElementVNode("span", null, _toDisplayString(contact.afterLink), 1)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.validationError), 1),
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.messageSuccess), 1),
            (_ctx.messageSuccess === '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
                      rows: "1",
                      class: _normalizeClass([_ctx.nameClass, "duration-400 block w-full resize-none rounded-sm border-0 bg-slate-900 p-2 text-slate-300 placeholder-slate-500 caret-slate-300 outline-none ring-1 ring-slate-500 ring-offset-slate-800 transition focus:bg-slate-900"]),
                      placeholder: "Name"
                    }, null, 2), [
                      [_vModelText, _ctx.name]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
                      rows: "1",
                      class: _normalizeClass([_ctx.emailClass, "duration-400 block w-full resize-none rounded-sm border-0 bg-slate-900 p-2 text-slate-300 placeholder-slate-500 caret-slate-300 outline-none ring-1 ring-slate-500 ring-offset-slate-800 transition focus:bg-slate-900"]),
                      placeholder: "Email"
                    }, null, 2), [
                      [_vModelText, _ctx.email]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.messageSuccess === '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.linkedin) = $event)),
                    rows: "1",
                    class: _normalizeClass([_ctx.linkedinClass, "duration-400 block w-full resize-none rounded-sm border-0 bg-slate-900 p-2 text-slate-300 placeholder-slate-500 caret-slate-300 outline-none ring-1 ring-slate-500 ring-offset-slate-800 transition focus:bg-slate-900"]),
                    placeholder: "Linkedin profile (optional)"
                  }, null, 2), [
                    [_vModelText, _ctx.linkedin]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.messageSuccess === '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.message) = $event)),
                    rows: "7",
                    class: _normalizeClass([_ctx.messageClass, "duration-400 block min-h-10 w-full resize-y rounded-sm border-0 bg-slate-900 p-2 text-slate-300 placeholder-slate-500 caret-slate-300 outline-none ring-1 ring-slate-500 ring-offset-slate-800 transition focus:bg-slate-900"]),
                    placeholder: "Write your message here..."
                  }, null, 2), [
                    [_vModelText, _ctx.message]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.messageSuccess === '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.acceptedPrivacy) = $event)),
                      class: _normalizeClass([_ctx.acceptedPrivacyClass, "mr-2 h-4 w-4 rounded checked:accent-amber-500"])
                    }, null, 2), [
                      [_vModelCheckbox, _ctx.acceptedPrivacy]
                    ]),
                    _createElementVNode("span", _hoisted_19, [
                      _createTextVNode("Agree with "),
                      _createVNode(_component_router_link, {
                        class: "text-amber-500",
                        to: "/privacy-policy"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Privacy Policy")
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" ?")
                    ])
                  ]),
                  _createElementVNode("div", {
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.sendEmail && _ctx.sendEmail(...args))),
                    class: "text-md material-symbols-outlined flex items-center justify-center rounded-full p-1 font-light text-slate-100 hover:bg-amber-500"
                  }, "send")
                ]))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactTypes, (contact, key) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "mt-10 space-x-1 px-[4%] xl:hidden",
              key: key
            }, [
              _createElementVNode("span", null, _toDisplayString(contact.beforeLink), 1),
              _createElementVNode("a", {
                class: "text-amber-500",
                href: contact.link,
                target: "_blank"
              }, _toDisplayString(contact.linkText), 9, _hoisted_20),
              _createElementVNode("span", null, _toDisplayString(contact.afterLink), 1)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}